module.exports = __webpack_public_path__ + "img/avatar_1.c6c9f347.jpg";